module.exports = __webpack_public_path__ + "img/免费.f46e9885.png";